import { navigate } from 'gatsby';

// const encode = (data) => {
// 	return Object.keys(data)
// 		.map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
// 		.join('&')
// }

const encode = (data) => {
  const formData = new FormData();

  for (const key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return formData;
}
 
 export const submitForm = (formdata, formName, action) => {

		fetch('/', {
			method: 'POST',
			body: encode({
				'form-name': formName,
				...formdata,
			}),
		})
			.then(() => navigate(action))
			.catch((error) => alert(error))

 }